export default __webpack_public_path__ + "static/media/mascote-corpo.adf57f57.webp";